import React from "react";
import Routes from "./Routes";
import { StripeProvider } from './contexts/StripeContext';
import { ThemeProvider } from './contexts/ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <StripeProvider>
        <Routes />
      </StripeProvider>
    </ThemeProvider>
  );
}

export default App;
